import AceIdentity, {
  AceIdentityEnv,
  AceIdentityLoginUrl,
} from '@ace-clublabs/ace-identity';

import { Environments, getEnvironmentFromHost } from '@/endpoints';
import type { TypedAceIdentity } from '@/types/AceIdentity';

const getAceIdentityEnv = (): AceIdentityEnv => {
  const env = getEnvironmentFromHost(window.location.hostname);

  return env === Environments.prod
    ? AceIdentityEnv.Prod
    : AceIdentityEnv.NonProd;
};

const getLoginUrl = (): AceIdentityLoginUrl | string => {
  const hostname = window.location.hostname;
  const env = getEnvironmentFromHost(hostname);

  if (env === Environments.prod) {
    return AceIdentityLoginUrl.Prod;
  }

  if (env === Environments.development) {
    return AceIdentityLoginUrl.Uat1;
  }

  return `https://${hostname}/enterprise/identity/${env}/#/login`;
};

const getRedirectUri = (): string => {
  const env = getEnvironmentFromHost(window.location.hostname);

  if (env === Environments.development) {
    return 'https://travelassistant.app.ace.aaa.com:3000';
  }

  return window.location.href;
};

export const getAuthUserInfo = async () => {
  const aceIdentity = new AceIdentity({
    env: getAceIdentityEnv(),
    loginUrl: getLoginUrl(),
    redirectUri: getRedirectUri(),
    bypassAuth2: true,
    disableBypassPkce: true,
  }) as TypedAceIdentity;

  const oktaClient = aceIdentity.oktaAuth();
  const isAuthenticated = await oktaClient.session.exists();

  if (!isAuthenticated) {
    return null;
  }

  const tokens = await oktaClient.token.getWithoutPrompt({
    scopes: [
      'profile',
      'clubCode',
      'scope',
      'openid',
      'customerId',
      'membershipStatus',
    ],
  });

  const userInfo = await oktaClient.token.getUserInfo(
    tokens.tokens.accessToken,
    tokens.tokens.idToken,
  );

  return userInfo;
};
